import { get, isEmpty, map, sumBy } from 'lodash';

import { createSelector } from 'reselect';
import { dateFormats } from '../../common/constants/chart-options';
import { parseTime } from '../../utils/chart-utils';

// DMARC Auth
const rawDmarcAuthSelector = state => get( state, 'dmarc.authentication', {} );
export const dmarcAuthIsLoadingSelector = state => get( state, 'dmarc.authenticationIsLoading', false );
export const dmarcAuthIsLoadedSelector = state => !get( state, 'dmarc.authenticationIsLoading', false ) && !isEmpty( get( state, 'dmarc.authentication', {} ) );
export const prevDmarcAuthParamsSelector = state => get( state, 'dmarc.authenticationParams' );

export const authTableIsExportingGridToCSV = state => get( state, 'exportReport.isExportingCSV.authentication', false );

export const flattenedDmarcAuthSelector = createSelector( rawDmarcAuthSelector, ( rawData ) => {
    return map( rawData, ( row, date ) => {
        let passRate = 0;
        let failRate = 0;

        if( row.total > 0 ){
            passRate = ( ( row.pass / row.total ) * 100 );
            failRate = ( ( row.fail / row.total ) * 100 );
        };

        return {
            date,
            failCount: row.fail,
            failRate: failRate.toFixed( 2 ),
            passCount: row.pass,
            passRate: passRate.toFixed( 2 ),
            total: row.total
        };
    } );
} );

export const dmarcAuthVisSelector = createSelector( flattenedDmarcAuthSelector, ( dmarcAuthData ) => {
    return map( dmarcAuthData, ( row ) => {
        return {
            ...row,
            date: parseTime( dateFormats.STANDARD_DATE )( row.date )
        };
    } );
} );

export const avgDmarcAuthRateSelector = createSelector(
    flattenedDmarcAuthSelector,
    ( dmarcAuthData ) => {
        const sumPass = sumBy( dmarcAuthData, 'passCount' );
        const sumTotal = sumBy( dmarcAuthData, 'total' );
        const avg = ( sumPass / sumTotal ) * 100 || 0;

        return avg.toFixed( 2 );
    }
);
